import React from 'react'

export const RussianFlag = ({ className = "w-8 h-8" }) => {
  return (
    <svg 
      viewBox="0 0 3 2" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <rect width="3" height="0.667" fill="#fff"/>
      <rect y="0.667" width="3" height="0.667" fill="#0039a6"/>
      <rect y="1.333" width="3" height="0.667" fill="#d52b1e"/>
    </svg>
  )
}

export const BritishFlag = ({ className = "w-8 h-8" }) => {
  return (
    <svg 
      viewBox="0 0 3 2" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <rect width="3" height="2" fill="#012169"/>
      <path d="M0 0 L3 2 M3 0 L0 2" stroke="#fff" strokeWidth="0.25" strokeLinecap="round"/>
      <path d="M0 0 L3 2 M3 0 L0 2" stroke="#C8102E" strokeWidth="0.18" strokeLinecap="round"/>
      <path d="M1.5 0 L1.5 2 M0 1 L3 1" stroke="#fff" strokeWidth="0.25" strokeLinecap="round"/>
      <path d="M1.5 0 L1.5 2 M0 1 L3 1" stroke="#C8102E" strokeWidth="0.18" strokeLinecap="round"/>
    </svg>
  )
}

export const SpanishFlag = ({ className = "w-8 h-8" }) => {
  return (
    <svg 
      viewBox="0 0 3 2" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <rect width="3" height="0.5" fill="#AA151B"/>
      <rect y="0.5" width="3" height="1" fill="#F1BF00"/>
      <rect y="1.5" width="3" height="0.5" fill="#AA151B"/>
    </svg>
  )
}

